import { PropsOf } from 'types';

import CaptionsForm from './CaptionsForm';
import connect from './connect';

type Props = PropsOf<ReturnType<typeof connect>>;

export default connect(CaptionsForm);
export { Props as CaptionsFormProps };
